import React from 'react'

import { First2019Meeting } from '../../../config/images'

const First2019MeetingArray = [
	{ path: '53048572_2452963678112142_1664228225800208384_o-thumb.jpg', w: 150, h: 76 },
	{ path: '53048572_2452963678112142_1664228225800208384_o.jpg', w: 1200, h: 604 },
	{ path: '52803643_2452964194778757_1748098577629970432_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52803643_2452964194778757_1748098577629970432_o.jpg', w: 1200, h: 800 },
	{ path: '52491596_2452964918112018_2328485363833634816_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52491596_2452964918112018_2328485363833634816_o.jpg', w: 1200, h: 800 },
	{ path: '52475639_2452965641445279_5970939182158184448_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52475639_2452965641445279_5970939182158184448_o.jpg', w: 1200, h: 800 },
	{ path: '52577813_2452967691445074_4483648924459991040_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52577813_2452967691445074_4483648924459991040_o.jpg', w: 1200, h: 800 },
	{ path: '52633974_2452968281445015_2207410128385212416_o-thumb.jpg', w: 150, h: 97 },
	{ path: '52633974_2452968281445015_2207410128385212416_o.jpg', w: 1200, h: 774 },
	{ path: '52574050_2452968941444949_2327038187488149504_o-thumb.jpg', w: 150, h: 97 },
	{ path: '52574050_2452968941444949_2327038187488149504_o.jpg', w: 1200, h: 778 },
	{ path: '52608893_2452969954778181_4556521656046059520_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52608893_2452969954778181_4556521656046059520_o.jpg', w: 1200, h: 800 },
	{ path: '52561441_2452970831444760_4023275782343229440_o-thumb.jpg', w: 150, h: 225 },
	{ path: '52561441_2452970831444760_4023275782343229440_o.jpg', w: 720, h: 1080 },
	{ path: '52991436_2452971488111361_7098283413488009216_o-thumb.jpg', w: 150, h: 94 },
	{ path: '52991436_2452971488111361_7098283413488009216_o.jpg', w: 1200, h: 753 },
	{ path: '52561523_2452972101444633_3139548555673337856_o-thumb.jpg', w: 150, h: 103 },
	{ path: '52561523_2452972101444633_3139548555673337856_o.jpg', w: 1200, h: 824 },
	{ path: '52961886_2452972804777896_6573993100648120320_o-thumb.jpg', w: 150, h: 96 },
	{ path: '52961886_2452972804777896_6573993100648120320_o.jpg', w: 1200, h: 766 },
	{ path: '52402687_2452973571444486_2479255230072487936_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52402687_2452973571444486_2479255230072487936_o.jpg', w: 1200, h: 800 },
	{ path: '52854030_2452974161444427_3956256696044617728_o-thumb.jpg', w: 150, h: 225 },
	{ path: '52854030_2452974161444427_3956256696044617728_o.jpg', w: 720, h: 1080 },
	{ path: '52794042_2452975624777614_6157195421111287808_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52794042_2452975624777614_6157195421111287808_o.jpg', w: 1200, h: 800 },
	{ path: '52822948_2452976194777557_2845563683554197504_o-thumb.jpg', w: 150, h: 225 },
	{ path: '52822948_2452976194777557_2845563683554197504_o.jpg', w: 720, h: 1080 },
	{ path: '53041418_2452976588110851_8775738261659189248_o-thumb.jpg', w: 150, h: 100 },
	{ path: '53041418_2452976588110851_8775738261659189248_o.jpg', w: 1200, h: 800 },
	{ path: '52692361_2452977061444137_8089263940703354880_o-thumb.jpg', w: 150, h: 63 },
	{ path: '52692361_2452977061444137_8089263940703354880_o.jpg', w: 1200, h: 503 },
	{ path: '52611650_2452978408110669_175271542266003456_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52611650_2452978408110669_175271542266003456_o.jpg', w: 1200, h: 800 },
	{ path: '52765579_2452978711443972_752778149170774016_o-thumb.jpg', w: 150, h: 95 },
	{ path: '52765579_2452978711443972_752778149170774016_o.jpg', w: 1200, h: 757 },
	{ path: '53320013_2452979161443927_4486584027800666112_o-thumb.jpg', w: 150, h: 92 },
	{ path: '53320013_2452979161443927_4486584027800666112_o.jpg', w: 1200, h: 732 },
	{ path: '52106851_2452979768110533_3402555168716226560_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52106851_2452979768110533_3402555168716226560_o.jpg', w: 1200, h: 800 },
	{ path: '52775099_2452980754777101_1257872728451448832_o-thumb.jpg', w: 150, h: 92 },
	{ path: '52775099_2452980754777101_1257872728451448832_o.jpg', w: 1200, h: 736 },
	{ path: '52469098_2452981244777052_6867103998462132224_o-thumb.jpg', w: 150, h: 99 },
	{ path: '52469098_2452981244777052_6867103998462132224_o.jpg', w: 1200, h: 791 },
	{ path: '52753354_2452981801443663_7534134633101787136_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52753354_2452981801443663_7534134633101787136_o.jpg', w: 1200, h: 800 },
	{ path: '52573998_2452982388110271_9203069936899981312_o-thumb.jpg', w: 150, h: 107 },
	{ path: '52573998_2452982388110271_9203069936899981312_o.jpg', w: 1200, h: 859 },
	{ path: '52777712_2452983104776866_8971523499738791936_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52777712_2452983104776866_8971523499738791936_o.jpg', w: 1200, h: 800 },
	{ path: '52786720_2452983574776819_5346182995785023488_o-thumb.jpg', w: 150, h: 225 },
	{ path: '52786720_2452983574776819_5346182995785023488_o.jpg', w: 720, h: 1080 },
	{ path: '52528728_2452984714776705_5966740946115624960_o-thumb.jpg', w: 150, h: 98 },
	{ path: '52528728_2452984714776705_5966740946115624960_o.jpg', w: 1200, h: 780 },
	{ path: '52732928_2452985544776622_7889796184779259904_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52732928_2452985544776622_7889796184779259904_o.jpg', w: 1200, h: 800 },
	{ path: '53010624_2452986211443222_6869847533376503808_o-thumb.jpg', w: 150, h: 102 },
	{ path: '53010624_2452986211443222_6869847533376503808_o.jpg', w: 1200, h: 816 },
	{ path: '52950143_2452986651443178_1791500381797220352_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52950143_2452986651443178_1791500381797220352_o.jpg', w: 1200, h: 800 },
	{ path: '53095660_2452987048109805_4819125517120700416_o-thumb.jpg', w: 150, h: 108 },
	{ path: '53095660_2452987048109805_4819125517120700416_o.jpg', w: 1200, h: 866 },
	{ path: '52654473_2452987541443089_1575101491130138624_o-thumb.jpg', w: 150, h: 105 },
	{ path: '52654473_2452987541443089_1575101491130138624_o.jpg', w: 1200, h: 843 },
	{ path: '52585239_2452987921443051_6611069092298227712_o-thumb.jpg', w: 150, h: 103 },
	{ path: '52585239_2452987921443051_6611069092298227712_o.jpg', w: 1200, h: 824 },
	{ path: '53152820_2452988381443005_2203642063382118400_o-thumb.jpg', w: 150, h: 100 },
	{ path: '53152820_2452988381443005_2203642063382118400_o.jpg', w: 1200, h: 800 },
	{ path: '52793024_2452989464776230_4195275551667126272_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52793024_2452989464776230_4195275551667126272_o.jpg', w: 1200, h: 800 },
	{ path: '52569195_2452989884776188_3241334006368698368_o-thumb.jpg', w: 150, h: 106 },
	{ path: '52569195_2452989884776188_3241334006368698368_o.jpg', w: 1200, h: 846 },
	{ path: '53355843_2452990924776084_8254003763598065664_o-thumb.jpg', w: 150, h: 100 },
	{ path: '53355843_2452990924776084_8254003763598065664_o.jpg', w: 1200, h: 800 },
	{ path: '52708369_2453001788108331_6101432683886280704_o-thumb.jpg', w: 150, h: 100 },
	{ path: '52708369_2453001788108331_6101432683886280704_o.jpg', w: 1200, h: 800 },
	{ path: '52820237_2453002244774952_2918221426257297408_o-thumb.jpg', w: 150, h: 99 },
	{ path: '52820237_2453002244774952_2918221426257297408_o.jpg', w: 1200, h: 790 },
	{ path: '52678040_2453005794774597_6641276095507202048_o-thumb.jpg', w: 150, h: 97 },
	{ path: '52678040_2453005794774597_6641276095507202048_o.jpg', w: 1200, h: 772 },
]

// const newArray = First2019MeetingArray.sort((a, b) => {
// 	if (a.path < b.path) return -1
// 	if (a.path > b.path) return 1
// 	return 0
// })

//TODO: To improve this group thumb and full and make a nice full object.

export default () => {
	const componentArray = []
	for (let i = 0; i < First2019MeetingArray.length; i++) {
		componentArray.push(
			<figure
				itemProp="associatedMedia"
				itemScope="itemScope"
				itemType="http://schema.org/ImageObject"
				key={First2019MeetingArray[i].path}
			>
				<a
					href={First2019Meeting[First2019MeetingArray[i + 1].path]}
					itemProp="contentUrl"
					data-size={`${First2019MeetingArray[i + 1].w}x${
						First2019MeetingArray[i + 1].h
					}`}
				>
					<img
						src={First2019Meeting[First2019MeetingArray[i].path]}
						itemProp="thumbnail"
						alt="description"
					/>
				</a>
				<figcaption itemProp="caption description">
					{First2019MeetingArray[i + 1].caption}
				</figcaption>
			</figure>
		)
		i++
	}
	return componentArray
}
